import SectionHeader from "../../../util/component/SectionHeader";
import {Box} from "@mui/material";
import ProfileSearch from "../component/ProfileSearch";
import ProfileTable from "../component/ProfileTable";
import {useTranslation} from "react-i18next";
import CustomContentWrapper from "../../../util/component/CustomContentWrapper";
import NotAuthorizedDialog from "../../authentication/component/NotAuthorizedDialog";
import {useHasScope} from "../../../config/globalConfig";

const ProfileList = () => {
    const {t} = useTranslation(['operator']);
    const hasScope = useHasScope;
    return (
        <Box>
            <SectionHeader title={t('label.profileList')}/>
            <CustomContentWrapper>
                {hasScope('SCOPE_VIEW_PROFILE') ? <>
                    <ProfileSearch/>
                    <ProfileTable/>
                </> : <NotAuthorizedDialog/>}
            </CustomContentWrapper>
        </Box>
    );
}

export default ProfileList;
